/**
 * Attempt to extract the gRPC safe message from either the x-grpc-details or x-grpc-status headers.
 *
 * @param details the value of the x-grpc-details header
 * @param status the value of the x-grpc-status header
 * @param onDetailsError reeives a callback if the details header cannot be parsed as JSON. (allows for backwards compatibility)
 *
 * @returns
 */
export function getGRPCSafeMessage(
  details: string,
  status: string,
  onDetailsError: () => void = () => {},
): string | null {
  if (details) {
    const decoded = atob(details);
    try {
      return decoded ? JSON.parse(decoded)?.message ?? null : null;
    } catch {
      onDetailsError();
      return null;
    }
  }

  if (status) {
    const idx = status.indexOf(':');
    if (idx !== -1 && status.length > idx + 1) {
      return status.substring(idx + 1);
    }
  }

  return null;
}

/**
 * An Error type where the message has been extracted from gRPC safe message details.
 */
export class GRPCErrorWithSafeMessage extends Error {
  constructor(message: string) {
    super(message);
  }

  static fromHeaders(details: string, status: string): GRPCErrorWithSafeMessage | null {
    const message = getGRPCSafeMessage(details, status);
    return message ? new GRPCErrorWithSafeMessage(message) : null;
  }
}
